/**
 * Минималистичный SemVer-парсер (без зависимостей).
 * Поддерживает формат MAJOR.MINOR.PATCH.
 *
 * DRY: единственное место для сравнения версий во всём проекте.
 */
export function parseSemVer(version: string): [number, number, number] {
  const parts = version.replace(/^v/, '').split('.').map(Number)
  const [major = 0, minor = 0, patch = 0] = parts
  if ([major, minor, patch].some(isNaN)) return [0, 0, 0]
  return [major, minor, patch]
}

/**
 * Возвращает true если version `a` строго новее `b`.
 * "1.2.0" > "1.1.9" → true
 * "1.0.0" > "1.0.0" → false (равные не перезаписываются)
 */
export function isNewerVersion(a: string, b: string): boolean {
  const [aMaj, aMin, aPat] = parseSemVer(a)
  const [bMaj, bMin, bPat] = parseSemVer(b)
  if (aMaj !== bMaj) return aMaj > bMaj
  if (aMin !== bMin) return aMin > bMin
  return aPat > bPat
}
